import { Injectable, ComponentFactoryResolver, ComponentFactory, Type, ViewContainerRef, ComponentRef, ApplicationRef, Injector, EmbeddedViewRef } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription,tap ,filter } from 'rxjs';
import { DynamicScriptLoaderService } from '@shared/Services/dynamicScriptLoader.service';
import { StyleSheetService } from '@shared/Services/stylesheet.service';


export interface DockConfig {
	width?: number | string;
	height?: number | string;
	minimizedWidth?: number;
	gutter?: number;
	poppedOutDistance?: string,
	title?:string;
	dialogClass?: string;
	buttons?: Array<string>; /* id, html, buttonClass, click */
	animationSpeed?: number;
	opacity?: number;
	initialState?: 'modal' | 'docked' | 'minimized'; /* "modal", "docked", "minimized" */

	showClose?: boolean;
	showPopout?: boolean;
	showMinimize?: boolean;

	create?: (target) => void;
	open?: (target) => void;
	beforeClose?: (target) => void;
	close?: (target) => void;
	beforeMinimize?: (target) => void;
	minimize?: (target) => void;
	beforeRestore?: (target) => void;
	restore?: (target) => void;
	beforePopout?: (target) => void;
	popout?: (target) => void;
}

@Injectable()
export class DockModal {
	componentRef: ComponentRef<any>;
	scrollBarRef: PerfectScrollbar;
	navigateSubscription: Subscription;
	componentMap: Map<string, { componentRef: ComponentRef<any>, config: DockConfig }> = new Map();
	constructor(
		private loader: DynamicScriptLoaderService,
		private resolver: ComponentFactoryResolver,
		private appRef: ApplicationRef,
		private injector: Injector,
		styleSheet: StyleSheetService
	) { 
		styleSheet.load('admindock');
	}

	public open<T>(component: Type<T>, params?: Partial<T>, config?: DockConfig) {
		const componentFactory = this.resolver.resolveComponentFactory(component);
		this.injectComponent(componentFactory, params, config);
	}

	public injectComponent<T>(componentFactory: ComponentFactory<T>, params?: Partial<T>, config?: DockConfig,tableKey?:string,recordId?:number) {
		const identifier = tableKey && recordId ? `${tableKey}_${recordId}` : null;
		if (identifier && this.componentMap.has(identifier)) {
			const storedData = this.componentMap.get(identifier);
			this.componentRef = storedData.componentRef;
			const existingConfig = storedData.config || config; 
			this.openExistingComponent(existingConfig);
        } else {
            this.componentRef = componentFactory.create(this.injector);
            if (params) {
                for (var i = 0; i < Object.keys(params).length; i++) {
                    this.componentRef.instance[Object.keys(params)[i]] = params[Object.keys(params)[i]];
                }
            }
            this.appRef.attachView(this.componentRef.hostView);

            const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            import('jquery').then((jquery: any) => {
                window["jQuery"] = jquery.default;
                window["$"] = jquery.default;
                var $ = jquery.default;
                this.loader.importScript("admindock", "/assets/admindock/admindock.js").then(() => {
                    config.open = () => {
                        setTimeout(() => { this.scrollBarRef = new PerfectScrollbar(contentElement.parent()[0]) }, 500);
                    }
                    config.popout = (target) => {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'));
                        });
                    };
                    config.restore = (target) => {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'));
                        });
                    };
                    config.close = () => {
                        if (this.navigateSubscription) {
                            this.navigateSubscription.unsubscribe();
                        }
                    }

                    let contentElement = $(domElem).dockmodale(config);

                    contentElement.parent().parent().mousedown(() => {
                        setTimeout(() => { this.scrollBarRef.update() }, 250);
                    });

                    this.navigateSubscription = this.injector.get(Router).events
                        .pipe(
                            filter(event => event instanceof NavigationEnd),
                            tap(event => {
                                $(domElem).dockmodale("close");
                            })
                        )
                        .subscribe();

                    if (identifier) {
						this.componentMap.set(identifier, { componentRef: this.componentRef, config });
                    }
                });
            });
        }
    }
	private openExistingComponent(config?: DockConfig) {
        const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        import('jquery').then((jquery: any) => {
            window["jQuery"] = jquery.default;
            window["$"] = jquery.default;
            var $ = jquery.default;
            this.loader.importScript("admindock", "/assets/admindock/admindock.js").then(() => {
                config.open = () => {
                    setTimeout(() => { this.scrollBarRef = new PerfectScrollbar(contentElement.parent()[0]) }, 500);
                }
                config.popout = (target) => {
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    });
                };
                config.restore = (target) => {
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    });
                };
                config.close = () => {
                    if (this.navigateSubscription) {
                        this.navigateSubscription.unsubscribe();
                    }
                }

                let contentElement = $(domElem).dockmodale(config);

                contentElement.parent().parent().mousedown(() => {
                    setTimeout(() => { this.scrollBarRef.update() }, 250);
                });

                this.navigateSubscription = this.injector.get(Router).events
                    .pipe(
                        filter(event => event instanceof NavigationEnd),
                        tap(event => {
                            $(domElem).dockmodale("close");
                        })
                    )
                    .subscribe();
            });
        });
    }

    public checkAndOpenComponent(identifier: string, config?: DockConfig) {
        if (this.componentMap.has(identifier)) {
			const storedData = this.componentMap.get(identifier);
			this.componentRef = storedData.componentRef;
			const existingConfig = storedData.config || config; 
			this.openExistingComponent(existingConfig);
            return true;
        }
        return false;
    }
}